var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMedication = function SvgMedication(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-label": "Medication",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "AZ_DLS_Icons",
    transform: "translate(-285.000000, -230.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Library_Items-/-Title-/-Descriptions-Copy-7",
    transform: "translate(33.000000, 165.000000)",
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 16,
    letterSpacing: -0.0266666671
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 1.086957)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Medication",
    transform: "translate(285.000000, 230.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,1 C10.209139,1 12,2.790861 12,5 L12,11 C12,13.209139 10.209139,15 8,15 C5.790861,15 4,13.209139 4,11 L4,5 C4,2.790861 5.790861,1 8,1 Z M11,8.995 L5,8.995 L5,11 C5,12.6568542 6.34314575,14 8,14 C9.59768088,14 10.9036609,12.75108 10.9949073,11.1762728 L11,11 L11,8.995 Z M8,2 C6.40231912,2 5.09633912,3.24891996 5.00509269,4.82372721 L5,5 L5,7.995 L11,7.995 L11,5 C11,3.34314575 9.65685425,2 8,2 Z",
    id: "Icons/16/Medication",
    transform: "translate(8.000000, 8.000000) rotate(-45.000000) translate(-8.000000, -8.000000) "
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMedication);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "medication.ca1af4214c412a3dd2fdce3a25ceaf9a.svg";